import { render, staticRenderFns } from "./costo.html?vue&type=template&id=1759e880&"
import script from "./Costo.vue?vue&type=script&lang=js&"
export * from "./Costo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports